import { toCamelCase, toKebabCase } from './case';

export function parseStyle(style: object) {	
	let newStyle:any = Object.assign({}, style);

	Object.keys(newStyle).forEach((key:string) => {
		if (key.includes('-')) {
			const newKey = toCamelCase(key);
			newStyle[newKey] = newStyle[key];
			delete newStyle[key];
		}
	});
	
	return newStyle;
}

export function stringCss(object: any, noBracket = false) {
	let output = '';
	if (!noBracket) {
		output += `{`;
	}
	Object.keys(object).forEach((key: string) => {
		if (key === 'textDecoration' && object[key] === '') {
			output += toKebabCase(key);
			output += ':';
			output += `none`;
			output += '; ';
		}
		if (object[key] && object[key].length !== 0) {
			output += toKebabCase(key);
			output += ':';
			output += `${object[key]}`;
			output += '; ';
		}	
	});
	if (!noBracket) {
		output += '}';
	}
	return output;	
}

export function addFontFamilyInherit(htmlString) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlString, 'text/html');
	const divs = doc.body.querySelectorAll('div');
	divs.forEach(div => {
		if (div.parentElement === doc.body) {
			const existingStyle = div.getAttribute('style') || '';
			const newStyle = `${existingStyle} font-family: inherit;`;
			div.setAttribute('style', newStyle);
		}
	});
	return doc.body.innerHTML;
}